function CarriersSlider(el) {
    this.el = el;

    new Flickity(this.el, {
        contain: true,
        prevNextButtons: false,
        imagesLoaded: true,
        pageDots: false
    });
}

(function() {
    const carriersSliderEl = document.querySelector('.jsCarriersSlider');
    if (carriersSliderEl) new CarriersSlider(carriersSliderEl);
})();